/**
 * Ziffernblock der Touch-Kasse: Beträge werden wie an einer Registrierkasse
 * von rechts eingeschoben ("1" "2" "5" "0" → 12,50 €). Reine Cent-Arithmetik
 * (Regel 5), höchstens 9 Ziffern.
 */
export type ZiffernTaste =
  '0' | '1' | '2' | '3' | '4' | '5' | '6' | '7' | '8' | '9' | '00' | '⌫' | 'C';

export const ZIFFERN_TASTEN: readonly ZiffernTaste[] = [
  '7',
  '8',
  '9',
  '4',
  '5',
  '6',
  '1',
  '2',
  '3',
  '00',
  '0',
  '⌫',
];

const MAX_CENT = 999_999_999;

export function ziffernTaste(cent: number, taste: ZiffernTaste): number {
  switch (taste) {
    case 'C':
      return 0;
    case '⌫':
      return Math.floor(cent / 10);
    case '00':
      return Math.min(MAX_CENT, cent * 100);
    default: {
      const neu = cent * 10 + Number(taste);
      return neu > MAX_CENT ? cent : neu;
    }
  }
}

/** Tastaturtaste → Ziffernblocktaste (Ziffern, Rücktaste, Entf/Escape löschen). */
export function tastaturZuZiffer(key: string): ZiffernTaste | null {
  if (/^[0-9]$/.test(key)) {
    return key as ZiffernTaste;
  }
  if (key === 'Backspace') {
    return '⌫';
  }
  if (key === 'Delete' || key === 'Escape') {
    return 'C';
  }
  return null;
}
